<template>
  <div class="schedule-st--container">
    <div class="schedule-st--time">
      <form @submit.prevent="addTime">
        <div class="schedule-st--time-flex">
          <div class="input-block">
            <label>Часы</label>
            <select v-model="data.from_hour" v-bind:disabled="weekend">
              <option
                v-for="item in hourOptions"
                :key="item.value"
                v-bind:value="item.value"
                >{{ item.time }}</option>
            </select>
          </div>
          <div>
            <span>:</span>
          </div>
          <div class="input-block">
            <label>Минуты</label>
            <select v-model="data.from_minute" v-bind:disabled="weekend">
              <option
                v-for="item in minuteOptions"
                :key="item.value"
                v-bind:value="item.value"
              >{{ item.time }}</option>
            </select>
          </div>
          <div>-</div>
          <div class="input-block">
            <label>Часы</label>
            <select v-model="data.to_hour" v-bind:disabled="weekend">
              <option
                v-for="item in hourOptions"
                :key="item.value"
                v-bind:value="item.value"
                >{{ item.time }}</option
              >
            </select>
          </div>
          <div>
            <span>:</span>
          </div>
          <div class="input-block">
            <label>Минуты</label>
            <select v-model="data.to_minute" v-bind:disabled="weekend">
              <option
                v-for="item in minuteOptions"
                :key="item.value"
                v-bind:value="item.value"
              >{{ item.time }}</option>
            </select>
          </div>
        </div>
        <div class="schedule-st--popular-flex mrg-b-15">
          <div class="items">
            <div
                class="item"
                v-for="(item, index) in popular.time_from"
                :key="index"
                @click="setPopularTime(item, 'time_from')"
            >
              {{minuteToTime(item)}}
            </div>
          </div>
          <div class="items">
            <div
                class="item"
                v-for="(item, index) in popular.time_to"
                :key="index"
                @click="setPopularTime(item, 'time_to')"
            >
              {{minuteToTime(item)}}
            </div>
          </div>
        </div>
        <div class="input-block">
          <label>
            <input v-bind:disabled="weekend" type="checkbox" id="use_break" v-model="showBreak" />
            С перерывом
          </label>
        </div>
        <div class="input-block">
          <label>
            <input type="checkbox" id="use_weekend" v-model="weekend" />
            Сделать выходным (убрать расписание)
          </label>
        </div>

        <div v-show="showBreak" class="schedule-st--break-container">
          <div v-for="(item) in breaks" :key="item.id">
            <div class="schedule-st--time-flex">
              <div class="input-block">
                <label>Часы</label>
                <select v-model="item.break_from_hour" v-bind:disabled="weekend">
                  <option
                      v-for="item in hourOptions"
                      :key="item.value"
                      v-bind:value="item.value"
                  >{{ item.time }}</option>
                </select>
              </div>
              <div>
                <span>:</span>
              </div>
              <div class="input-block">
                <label>Минуты</label>
                <select v-model="item.break_from_minute" v-bind:disabled="weekend">
                  <option
                      v-for="item in minuteOptions"
                      :key="item.value"
                      v-bind:value="item.value"
                  >{{ item.time }}</option>
                </select>
              </div>
              <div>-</div>
              <div class="input-block">
                <label>Часы</label>
                <select v-model="item.break_to_hour" v-bind:disabled="weekend">
                  <option
                      v-for="item in hourOptions"
                      :key="item.value"
                      v-bind:value="item.value"
                  >{{ item.time }}</option
                  >
                </select>
              </div>
              <div>
                <span>:</span>
              </div>
              <div class="input-block">
                <label>Минуты</label>
                <select v-model="item.break_to_minute" v-bind:disabled="weekend">
                  <option
                      v-for="item in minuteOptions"
                      :key="item.value"
                      v-bind:value="item.value"
                  >{{ item.time }}</option
                  >
                </select>
              </div>
            </div>

            <div class="schedule-st--popular-flex mrg-b-15">
              <div class="items">
                <div
                    class="item mrg-t-10"
                    v-for="(popbreak, index) in popular.break_from"
                    :key="index"
                    @click="setPopularBreak(item.id, popbreak, 'break_from')"
                >
                  {{minuteToTime(popbreak)}}
                </div>
              </div>
              <div class="items">
                <div
                    class="item mrg-t-10"
                    v-for="(popbreak, index) in popular.break_to"
                    :key="index"
                    @click="setPopularBreak(item.id, popbreak, 'break_to')"
                >
                  {{minuteToTime(popbreak)}}
                </div>
              </div>
            </div>

          </div>

          <div @click="addBreak" class="btn btn-sm btn-info mrg-t-10">
            <f-awesome icon="plus"></f-awesome>
            Еще один перерыв
          </div>
          <div @click="removeBreak" class="btn btn-sm btn-danger mrg-t-10">
            <f-awesome icon="times"></f-awesome>
            Убрать последний
          </div>
        </div>

        <div class="input-block schedule-st--submit">
          <button type="submit" class="btn btn-sm btn-success">
            Применить
          </button>
          <div @click="resetValues" class="btn btn-sm btn-outline-info">Сбросить</div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Formatter from "../../libraries/Formatter";
import scheduleRepository from "../../../repositories/schedule";

const formatter = new Formatter();

export default {
  name: "ScheduleSetTime",
  components: {},
  data() {
    return {
      popular: {
        time_from: [],
        time_to: [],
        break_from: [],
        break_to: []
      },
      showBreak: false,
      weekend: false,
      breaks: [],
      data: {
        from_hour: 0,
        from_minute: 0,
        to_hour: 0,
        to_minute: 0,
      }
    };
  },
  props: {
    open: Boolean,
    selectedStaff: Array
  },
  watch: {
    weekend: function(val) {
      if (val) {
        for (let key in this.data) {
          this.data[key] = 0;
        }
        this.showBreak = false;
      }
    },
    open: function(val) {
      if (val === true) {
        this.getPopular(this.selectedStaff);
      }
    },
    showBreak: function(val){
      if(!val){
        this.breaks = [];
        this.addBreak();
      }
    }
  },
  computed: {
    hourOptions(){
      let result = [];
      for (let i = 0; i <= 23; i++) {
        let obj = {};
        obj.value = i;
        obj.time = i;
        result.push(obj);
      }
      return result;
    },
    minuteOptions(){
      let result = [];
      for (let i = 0; i <= 55; i = i + 5) {
        let obj = {};
        obj.value = i;
        obj.time = i;
        result.push(obj);
      }
      return result;
    }
  },
  methods: {
    getPopular(staffIds){
      scheduleRepository.getPopular({ staff_ids: JSON.stringify(staffIds) }).then(resp => {
        this.popular = resp.data;
      }).catch(err => {
        this.$store.dispatch("addNotification", {
          text: err.response.data.message,
          time: 6,
          color: "danger"
        });
      });
    },
    resetValues(){
      this.showBreak = false;
      this.weekend = false;
      this.data.from_hour = 0;
      this.data.from_minute = 0;
      this.data.to_hour = 0;
      this.data.to_minute = 0;

      this.breaks = [];
      this.addBreak();
    },
    removeBreak(){
      let breakCount = this.breaks.length;
      if(breakCount <= 1){
        this.$store.dispatch("addNotification", {
          text: 'Невозможно удалить. Если необходимо полностью убрать перерыв, то снимите галочку на пункте "С перерывом"',
          time: 5,
          color: "danger"
        });
        return false;
      }
      this.breaks.pop();
    },
    addBreak(){
      let breakCount = this.breaks.length;
      if(breakCount >= 10){
        this.$store.dispatch("addNotification", {
          text: 'Нельзя добавить более 10 перерывов',
          time: 3,
          color: "danger"
        });
        return false;
      }
      let breakFields = {
        id: breakCount,
        break_from_hour: 0,
        break_from_minute: 0,
        break_to_hour: 0,
        break_to_minute: 0
      };
      this.breaks.push(breakFields);
    },
    addTime() {
      let result = {};
      let breaks = this.breaks.slice();
      let breaksResult = [];

      if(this.showBreak){
        for(let keyBreak in breaks){
          let breakObj = {
            break_from: formatter.hourMinuteToMinute(breaks[keyBreak].break_from_hour, breaks[keyBreak].break_from_minute),
            break_to: formatter.hourMinuteToMinute(breaks[keyBreak].break_to_hour, breaks[keyBreak].break_to_minute)
          };
          breaksResult.push(breakObj);
        }
      }

      result.weekend = this.weekend;
      result.time_from = formatter.hourMinuteToMinute(this.data.from_hour, this.data.from_minute);
      result.time_to = formatter.hourMinuteToMinute(this.data.to_hour, this.data.to_minute);
      result.breaks = breaksResult;

      this.$emit("setTime", result);
    },
    setPopularTime(item, destination){
      let hourMinute = formatter.minuteSplitHourMinute(item);
      if(destination == 'time_from'){
        this.data.from_hour = hourMinute.hour;
        this.data.from_minute = hourMinute.minute;
      }else if(destination == 'time_to'){
        this.data.to_hour = hourMinute.hour;
        this.data.to_minute = hourMinute.minute;
      }
    },
    setPopularBreak(id, item, destination){
      let hourMinute = formatter.minuteSplitHourMinute(item);
      if(destination == 'break_from'){
        for(let key in this.breaks){
          if(+this.breaks[key].id === +id){
            this.breaks[key].break_from_hour = hourMinute.hour;
            this.breaks[key].break_from_minute = hourMinute.minute;
          }
        }
      }else if(destination == 'break_to'){
        for(let key in this.breaks){
          if(+this.breaks[key].id === +id){
            this.breaks[key].break_to_hour = hourMinute.hour;
            this.breaks[key].break_to_minute = hourMinute.minute;
          }
        }
      }
    },
    minuteToTime(minutes){
      return formatter.minuteToTime(minutes);
    }
  },
  created() {}
};
</script>

<style scoped lang="less">
.schedule-st--time-flex {
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-around;
  flex-direction: row;

  & > div:nth-of-type(1) {
    width: 22%;
  }
  & > div:nth-of-type(2) {
    text-align: center;
    line-height: 60px;
    width: 2%;
  }
  & > div:nth-of-type(3) {
    width: 22%;
  }
  & > div:nth-of-type(4) {
    width: 5%;
    text-align: center;
    line-height: 60px;
  }
  & > div:nth-of-type(5) {
    width: 22%;
  }
  & > div:nth-of-type(6) {
    width: 2%;
    text-align: center;
    line-height: 60px;
  }
  & > div:nth-of-type(7) {
    width: 22%;
  }
}

.schedule-st--popular-flex{
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-around;
  flex-direction: row;

  &>div{
    width: 43%;

    .item{
      display: inline-block;
      margin: 0 14px 10px 0;
      cursor: pointer;
      text-decoration: underline;
      color: #9a9999;
      font-size: 13px;
    }
  }
}

.schedule-st--submit {
  margin-top: 35px;
}
</style>
